var _metadata, _defs, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChuckFooter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "100%",
    xmlnsVectornator: "http://vectornator.io",
    viewBox: "0 0 1200 630",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("vectornatorSetting", {
    key: "DimensionsVisible",
    value: 1
  }), /*#__PURE__*/React.createElement("vectornatorSetting", {
    key: "New",
    value: 1
  }), /*#__PURE__*/React.createElement("vectornatorSetting", {
    key: "SnapToPoints",
    value: 0
  }), /*#__PURE__*/React.createElement("vectornatorSetting", {
    key: "OutlineMode",
    value: 0
  }), /*#__PURE__*/React.createElement("vectornatorSetting", {
    key: "RulersVisible",
    value: 1
  }), /*#__PURE__*/React.createElement("vectornatorSetting", {
    key: "GuidesVisible",
    value: 1
  }), /*#__PURE__*/React.createElement("vectornatorSetting", {
    key: "CMYKEnabledKey",
    value: 0
  }), /*#__PURE__*/React.createElement("vectornatorSetting", {
    key: "SnapToEdges",
    value: 1
  }), /*#__PURE__*/React.createElement("vectornatorSetting", {
    key: "DisplayWhiteBackground",
    value: 0
  }), /*#__PURE__*/React.createElement("vectornatorSetting", {
    key: "SnapToGuides",
    value: 1
  }), /*#__PURE__*/React.createElement("vectornatorSetting", {
    key: "Units",
    value: "Pixels"
  }), /*#__PURE__*/React.createElement("vectornatorSetting", {
    key: "GridSpacing",
    value: 36
  }), /*#__PURE__*/React.createElement("vectornatorSetting", {
    key: "SnapToGrid",
    value: 0
  }), /*#__PURE__*/React.createElement("vectornatorSetting", {
    key: "DynamicGuides",
    value: 1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: 312.459,
    r: 15.4704,
    id: "RadialGradient",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.00191 0 0 1.00191 761.129 3.48573)",
    cy: 421.839
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.994949,
    stopColor: "#001110",
    offset: 1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 466.583,
    r: 0.753784,
    id: "RadialGradient_2",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 3.29019 85.6107)",
    cy: 223.817
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.46947,
    stopColor: "#fd7800",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 585.611,
    r: 576.167,
    id: "RadialGradient_3",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 9 57)",
    cy: 504.891
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.994949,
    stopColor: "#eff8f7",
    offset: 1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 585.119,
    r: 573.788,
    id: "RadialGradient_4",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.00396 0 0 1.04954 7.2761 33.7741)",
    cy: 483.274
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.994949,
    stopColor: "#dce5e4",
    offset: 1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 1074.58,
    r: 21.3608,
    id: "RadialGradient_5",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0.842663 0 0 0.842663 168.711 77.8272)",
    cy: 502.81
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.994949,
    stopColor: "#001110",
    offset: 1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 1074.58,
    r: 21.3608,
    id: "RadialGradient_6",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0.842663 0 0 0.842663 -593.025 77.8272)",
    cy: 502.81
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.994949,
    stopColor: "#001110",
    offset: 1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffffff",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1",
    vectornatorLayerName: "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 8,
    d: "M421.961+200.96L935.715+200.96C940.133+200.96+943.715+204.542+943.715+208.96L943.715+425.438C943.715+429.857+940.133+433.438+935.715+433.438L421.961+433.438C417.543+433.438+413.961+429.857+413.961+425.438L413.961+208.96C413.961+204.542+417.543+200.96+421.961+200.96Z",
    fill: "#8abeec",
    strokeLinecap: "butt",
    opacity: 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.99+418.823L1082.38+418.823C1086.41+418.823+1089.69+422.095+1089.69+426.131L1089.69+426.131C1089.69+430.167+1086.41+433.438+1082.38+433.438L1065.99+433.438C1061.96+433.438+1058.69+430.167+1058.69+426.131L1058.69+426.131C1058.69+422.095+1061.96+418.823+1065.99+418.823Z",
    opacity: 1,
    fill: "url(#RadialGradient)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.741+371.919L317.423+371.919C321.651+371.919+325.079+375.347+325.079+379.575L325.079+518.544C325.079+522.772+321.651+526.2+317.423+526.2L307.741+526.2C303.513+526.2+300.085+522.772+300.085+518.544L300.085+379.575C300.085+375.347+303.513+371.919+307.741+371.919Z",
    opacity: 1,
    fill: "#2a3e3c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1069.44+371.919L1079.12+371.919C1083.35+371.919+1086.78+375.347+1086.78+379.575L1086.78+518.544C1086.78+522.772+1083.35+526.2+1079.12+526.2L1069.44+526.2C1065.21+526.2+1061.78+522.772+1061.78+518.544L1061.78+379.575C1061.78+375.347+1065.21+371.919+1069.44+371.919Z",
    opacity: 1,
    fill: "#2a3e3c"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dabca4",
    strokeWidth: 0.1,
    d: "M469.119+308.925L470.627+308.925L470.627+309.93L469.119+309.93L469.119+308.925Z",
    fill: "url(#RadialGradient_2)",
    strokeLinecap: "butt",
    opacity: 0.1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dabca4",
    strokeWidth: 0.1,
    d: "M436.808+214.848L577.153+214.848C581.763+214.848+585.5+218.252+585.5+222.451L585.5+395.167C585.5+399.366+581.763+402.77+577.153+402.77L436.808+402.77C432.198+402.77+428.461+399.366+428.461+395.167L428.461+222.451C428.461+218.252+432.198+214.848+436.808+214.848Z",
    fill: "#0b132b",
    strokeLinecap: "butt",
    opacity: 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.915+228.376L562.755+228.376C566.374+228.376+569.309+231.181+569.309+234.641L569.309+258.831C569.309+262.291+566.374+265.096+562.755+265.096L451.915+265.096C448.295+265.096+445.361+262.291+445.361+258.831L445.361+234.641C445.361+231.181+448.295+228.376+451.915+228.376Z",
    opacity: 0.989868,
    fill: "#3a506b"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dabca4",
    strokeWidth: 0.1,
    d: "M542.265+284.302L563.684+284.302C567.143+284.302+569.948+287.107+569.948+290.567L569.948+329.307C569.948+332.766+567.143+335.571+563.684+335.571L542.265+335.571C538.805+335.571+536+332.766+536+329.307L536+290.567C536+287.107+538.805+284.302+542.265+284.302Z",
    fill: "#3a506b",
    strokeLinecap: "butt",
    opacity: 0.989868,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dabca4",
    strokeWidth: 0.1,
    d: "M541.771+340.8L563.19+340.8C566.65+340.8+569.455+343.605+569.455+347.065L569.455+385.804C569.455+389.264+566.65+392.069+563.19+392.069L541.771+392.069C538.311+392.069+535.507+389.264+535.507+385.804L535.507+347.065C535.507+343.605+538.311+340.8+541.771+340.8Z",
    fill: "#3a506b",
    strokeLinecap: "butt",
    opacity: 0.989868,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dabca4",
    strokeWidth: 0.1,
    d: "M451.265+284.302L472.684+284.302C476.143+284.302+478.948+287.107+478.948+290.567L478.948+329.307C478.948+332.766+476.143+335.571+472.684+335.571L451.265+335.571C447.805+335.571+445+332.766+445+329.307L445+290.567C445+287.107+447.805+284.302+451.265+284.302Z",
    fill: "#3a506b",
    strokeLinecap: "butt",
    opacity: 0.989868,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dabca4",
    strokeWidth: 0.1,
    d: "M450.771+340.8L472.19+340.8C475.65+340.8+478.455+343.605+478.455+347.065L478.455+385.804C478.455+389.264+475.65+392.069+472.19+392.069L450.771+392.069C447.311+392.069+444.507+389.264+444.507+385.804L444.507+347.065C444.507+343.605+447.311+340.8+450.771+340.8Z",
    fill: "#3a506b",
    strokeLinecap: "butt",
    opacity: 0.989868,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dabca4",
    strokeWidth: 0.1,
    d: "M497.265+284.302L518.684+284.302C522.143+284.302+524.948+287.107+524.948+290.567L524.948+329.307C524.948+332.766+522.143+335.571+518.684+335.571L497.265+335.571C493.805+335.571+491+332.766+491+329.307L491+290.567C491+287.107+493.805+284.302+497.265+284.302Z",
    fill: "#3a506b",
    strokeLinecap: "butt",
    opacity: 0.989868,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dabca4",
    strokeWidth: 0.1,
    d: "M496.771+340.8L518.19+340.8C521.65+340.8+524.455+343.605+524.455+347.065L524.455+385.804C524.455+389.264+521.65+392.069+518.19+392.069L496.771+392.069C493.311+392.069+490.507+389.264+490.507+385.804L490.507+347.065C490.507+343.605+493.311+340.8+496.771+340.8Z",
    fill: "#3a506b",
    strokeLinecap: "butt",
    opacity: 0.989868,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dabca4",
    strokeWidth: 0.1,
    d: "M718.878+218.29L894.388+218.29C897.69+218.29+900.366+220.814+900.366+223.928L900.366+404.534C900.366+407.647+897.69+410.171+894.388+410.171L718.878+410.171C715.576+410.171+712.899+407.647+712.899+404.534L712.899+223.928C712.899+220.814+715.576+218.29+718.878+218.29Z",
    fill: "#252525",
    strokeLinecap: "butt",
    opacity: 0.989868,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dabca4",
    strokeWidth: 0.1,
    d: "M734.372+235.501L779.729+235.501C781.11+235.501+782.229+236.621+782.229+238.001L782.229+238.001C782.229+239.382+781.11+240.501+779.729+240.501L734.372+240.501C732.991+240.501+731.872+239.382+731.872+238.001L731.872+238.001C731.872+236.621+732.991+235.501+734.372+235.501Z",
    fill: "#ffffff",
    strokeLinecap: "butt",
    opacity: 0.989868,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dabca4",
    strokeWidth: 0.1,
    d: "M735.367+250.827L762.876+250.827C764.256+250.827+765.376+251.946+765.376+253.327L765.376+253.327C765.376+254.708+764.256+255.827+762.876+255.827L735.367+255.827C733.987+255.827+732.867+254.708+732.867+253.327L732.867+253.327C732.867+251.946+733.987+250.827+735.367+250.827Z",
    fill: "#ffffff",
    strokeLinecap: "butt",
    opacity: 0.989868,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dabca4",
    strokeWidth: 0.1,
    d: "M735.367+265.698L762.876+265.698C764.256+265.698+765.376+266.817+765.376+268.198L765.376+268.198C765.376+269.578+764.256+270.698+762.876+270.698L735.367+270.698C733.987+270.698+732.867+269.578+732.867+268.198L732.867+268.198C732.867+266.817+733.987+265.698+735.367+265.698Z",
    fill: "#ffffff",
    strokeLinecap: "butt",
    opacity: 0.989868,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dabca4",
    strokeWidth: 0.1,
    d: "M759.878+254.248L759.901+254.248C759.928+254.248+759.949+254.269+759.949+254.296L759.949+254.296C759.949+254.323+759.928+254.344+759.901+254.344L759.878+254.344C759.851+254.344+759.83+254.323+759.83+254.296L759.83+254.296C759.83+254.269+759.851+254.248+759.878+254.248Z",
    fill: "#ffffff",
    strokeLinecap: "butt",
    opacity: 0.989868,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dabca4",
    strokeWidth: 0.1,
    d: "M773.503+250.827L850.873+250.827C852.254+250.827+853.373+251.946+853.373+253.327L853.373+253.327C853.373+254.708+852.254+255.827+850.873+255.827L773.503+255.827C772.123+255.827+771.003+254.708+771.003+253.327L771.003+253.327C771.003+251.946+772.123+250.827+773.503+250.827Z",
    fill: "#75ee72",
    strokeLinecap: "butt",
    opacity: 0.989868,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dabca4",
    strokeWidth: 0.1,
    d: "M776.735+265.698L836.203+265.698C837.584+265.698+838.703+266.817+838.703+268.198L838.703+268.198C838.703+269.578+837.584+270.698+836.203+270.698L776.735+270.698C775.354+270.698+774.235+269.578+774.235+268.198L774.235+268.198C774.235+266.817+775.354+265.698+776.735+265.698Z",
    fill: "#ffffff",
    strokeLinecap: "butt",
    opacity: 0.989868,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dabca4",
    strokeWidth: 0.1,
    d: "M789.495+235.501L822.247+235.501C823.628+235.501+824.747+236.621+824.747+238.001L824.747+238.001C824.747+239.382+823.628+240.501+822.247+240.501L789.495+240.501C788.115+240.501+786.995+239.382+786.995+238.001L786.995+238.001C786.995+236.621+788.115+235.501+789.495+235.501Z",
    fill: "#75ee72",
    strokeLinecap: "butt",
    opacity: 0.989868,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dabca4",
    strokeWidth: 0.1,
    d: "M735.367+278.48L767.055+278.48C768.436+278.48+769.555+279.599+769.555+280.98L769.555+280.98C769.555+282.361+768.436+283.48+767.055+283.48L735.367+283.48C733.987+283.48+732.867+282.361+732.867+280.98L732.867+280.98C732.867+279.599+733.987+278.48+735.367+278.48Z",
    fill: "#75ee72",
    strokeLinecap: "butt",
    opacity: 0.989868,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dabca4",
    strokeWidth: 0.1,
    d: "M891.02+222.43L891.02+222.43C892.4+222.43+893.52+223.549+893.52+224.93L893.52+224.988C893.52+226.369+892.4+227.488+891.02+227.488L891.02+227.488C889.639+227.488+888.52+226.369+888.52+224.988L888.52+224.93C888.52+223.549+889.639+222.43+891.02+222.43Z",
    fill: "#dd4848",
    strokeLinecap: "butt",
    opacity: 0.989868,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dabca4",
    strokeWidth: 0.1,
    d: "M575.435+220.471L575.435+220.471C576.815+220.471+577.935+221.591+577.935+222.971L577.935+223.03C577.935+224.41+576.815+225.53+575.435+225.53L575.435+225.53C574.054+225.53+572.935+224.41+572.935+223.03L572.935+222.971C572.935+221.591+574.054+220.471+575.435+220.471Z",
    fill: "#dd4848",
    strokeLinecap: "butt",
    opacity: 0.989868,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dabca4",
    strokeWidth: 0.1,
    d: "M882.394+222.43L882.394+222.43C883.774+222.43+884.894+223.549+884.894+224.93L884.894+224.988C884.894+226.369+883.774+227.488+882.394+227.488L882.394+227.488C881.013+227.488+879.894+226.369+879.894+224.988L879.894+224.93C879.894+223.549+881.013+222.43+882.394+222.43Z",
    fill: "#e2d270",
    strokeLinecap: "butt",
    opacity: 0.989868,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dabca4",
    strokeWidth: 0.1,
    d: "M566.809+220.471L566.809+220.471C568.189+220.471+569.309+221.591+569.309+222.971L569.309+223.03C569.309+224.41+568.189+225.53+566.809+225.53L566.809+225.53C565.428+225.53+564.309+224.41+564.309+223.03L564.309+222.971C564.309+221.591+565.428+220.471+566.809+220.471Z",
    fill: "#e2d270",
    strokeLinecap: "butt",
    opacity: 0.989868,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.805+233.001L536.464+233.001C539.043+233.001+541.134+234.792+541.134+237.001L541.134+237.001C541.134+239.21+539.043+241.001+536.464+241.001L481.805+241.001C479.225+241.001+477.134+239.21+477.134+237.001L477.134+237.001C477.134+234.792+479.225+233.001+481.805+233.001Z",
    opacity: 0.989868,
    fill: "#eee7e7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.296+418.823L320.681+418.823C324.717+418.823+327.989+422.095+327.989+426.131L327.989+426.131C327.989+430.167+324.717+433.438+320.681+433.438L304.296+433.438C300.26+433.438+296.989+430.167+296.989+426.131L296.989+426.131C296.989+422.095+300.26+418.823+304.296+418.823Z",
    opacity: 1,
    fill: "#2a3e3c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920+433.44C920+432.269+920.971+431.32+922.169+431.32C923.367+431.32+924.339+432.269+924.339+433.44C924.339+434.611+923.367+435.56+922.169+435.56C920.971+435.56+920+434.611+920+433.44Z",
    opacity: 1,
    fill: "#d6f2fa"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 8,
    d: "M101.493+227.737L381.415+227.737C386.387+227.737+390.417+231.884+390.417+236.999L390.417+398.91C390.417+404.025+386.387+408.171+381.415+408.171L101.493+408.171C96.5208+408.171+92.4901+404.025+92.4901+398.91L92.4901+236.999C92.4901+231.884+96.5208+227.737+101.493+227.737Z",
    fill: "#8abeec",
    strokeLinecap: "butt",
    opacity: 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.634+408.171C367.634+407.067+366.738+406.171+365.634+406.171C364.529+406.171+363.634+407.067+363.634+408.171C363.634+409.276+364.529+410.171+365.634+410.171C366.738+410.171+367.634+409.276+367.634+408.171Z",
    opacity: 1,
    fill: "#d6f2fa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.381+238.196L249.012+238.196C253.532+238.196+257.197+241.766+257.197+246.171L257.197+390.221C257.197+394.626+253.532+398.196+249.012+398.196L115.381+398.196C110.861+398.196+107.197+394.626+107.197+390.221L107.197+246.171C107.197+241.766+110.861+238.196+115.381+238.196Z",
    opacity: 0.989868,
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.461+242.648L244.235+242.648C248.716+242.648+252.348+246.158+252.348+250.487L252.348+379.04C252.348+383.369+248.716+386.878+244.235+386.878L150.461+386.878C145.98+386.878+142.348+383.369+142.348+379.04L142.348+250.487C142.348+246.158+145.98+242.648+150.461+242.648Z",
    opacity: 1,
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dabca4",
    strokeWidth: 0.1,
    d: "M244.314+245.648L244.314+245.648C245.695+245.648+246.814+246.768+246.814+248.148L246.814+248.207C246.814+249.587+245.695+250.707+244.314+250.707L244.314+250.707C242.933+250.707+241.814+249.587+241.814+248.207L241.814+248.148C241.814+246.768+242.933+245.648+244.314+245.648Z",
    fill: "#dd4848",
    strokeLinecap: "butt",
    opacity: 0.989868,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dabca4",
    strokeWidth: 0.1,
    d: "M235.688+245.648L235.688+245.648C237.069+245.648+238.188+246.768+238.188+248.148L238.188+248.207C238.188+249.587+237.069+250.707+235.688+250.707L235.688+250.707C234.307+250.707+233.188+249.587+233.188+248.207L233.188+248.148C233.188+246.768+234.307+245.648+235.688+245.648Z",
    fill: "#e2d270",
    strokeLinecap: "butt",
    opacity: 0.989868,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.237+253.648L133.335+253.648C134.732+253.648+135.864+254.781+135.864+256.177L135.864+256.177C135.864+257.574+134.732+258.707+133.335+258.707L117.237+258.707C115.84+258.707+114.708+257.574+114.708+256.177L114.708+256.177C114.708+254.781+115.84+253.648+117.237+253.648Z",
    opacity: 0.989868,
    fill: "#eee7e7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.659+263.648L136.441+263.648C138.071+263.648+139.392+264.781+139.392+266.177L139.392+266.177C139.392+267.574+138.071+268.707+136.441+268.707L117.659+268.707C116.029+268.707+114.708+267.574+114.708+266.177L114.708+266.177C114.708+264.781+116.029+263.648+117.659+263.648Z",
    opacity: 0.989868,
    fill: "#eee7e7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.767+273.648L129.876+273.648C131.013+273.648+131.935+274.781+131.935+276.177L131.935+276.177C131.935+277.574+131.013+278.707+129.876+278.707L116.767+278.707C115.63+278.707+114.708+277.574+114.708+276.177L114.708+276.177C114.708+274.781+115.63+273.648+116.767+273.648Z",
    opacity: 0.989868,
    fill: "#eee7e7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.237+283.648L133.335+283.648C134.732+283.648+135.864+284.781+135.864+286.177L135.864+286.177C135.864+287.574+134.732+288.707+133.335+288.707L117.237+288.707C115.84+288.707+114.708+287.574+114.708+286.177L114.708+286.177C114.708+284.781+115.84+283.648+117.237+283.648Z",
    opacity: 0.989868,
    fill: "#eee7e7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.237+293.648L133.335+293.648C134.732+293.648+135.864+294.781+135.864+296.177L135.864+296.177C135.864+297.574+134.732+298.707+133.335+298.707L117.237+298.707C115.84+298.707+114.708+297.574+114.708+296.177L114.708+296.177C114.708+294.781+115.84+293.648+117.237+293.648Z",
    opacity: 0.989868,
    fill: "#eee7e7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.31+349.646L130.263+349.646C134.418+349.646+137.786+352.722+137.786+356.517L137.786+376.352C137.786+380.147+134.418+383.223+130.263+383.223L120.31+383.223C116.154+383.223+112.786+380.147+112.786+376.352L112.786+356.517C112.786+352.722+116.154+349.646+120.31+349.646Z",
    opacity: 1,
    fill: "#df7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.641+262.648L170.459+262.648C175.393+262.648+179.392+266.301+179.392+270.807L179.392+294.358C179.392+298.864+175.393+302.517+170.459+302.517L158.641+302.517C153.707+302.517+149.708+298.864+149.708+294.358L149.708+270.807C149.708+266.301+153.707+262.648+158.641+262.648Z",
    opacity: 1,
    fill: "#9cdf7a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.641+262.648L205.459+262.648C210.393+262.648+214.392+266.301+214.392+270.807L214.392+294.358C214.392+298.864+210.393+302.517+205.459+302.517L193.641+302.517C188.707+302.517+184.708+298.864+184.708+294.358L184.708+270.807C184.708+266.301+188.707+262.648+193.641+262.648Z",
    opacity: 1,
    fill: "#b17adf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.641+262.648L240.459+262.648C245.393+262.648+249.392+266.301+249.392+270.807L249.392+294.358C249.392+298.864+245.393+302.517+240.459+302.517L228.641+302.517C223.707+302.517+219.708+298.864+219.708+294.358L219.708+270.807C219.708+266.301+223.707+262.648+228.641+262.648Z",
    opacity: 1,
    fill: "#df7ab3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#e7d8d8",
    strokeWidth: 1,
    d: "M180.816+392.295C180.816+390.085+182.607+388.294+184.816+388.294C187.025+388.294+188.816+390.085+188.816+392.295C188.816+394.505+187.025+396.296+184.816+396.296C182.607+396.296+180.816+394.505+180.816+392.295Z",
    fill: "none",
    strokeLinecap: "butt",
    opacity: 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.583+392.295L183.189+394.832L183.189+389.758L187.583+392.295Z",
    opacity: 0.920705,
    fill: "#e7d8d8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.76+250.707L178.081+250.707C179.592+250.707+180.816+251.931+180.816+253.442L180.816+253.442C180.816+254.953+179.592+256.177+178.081+256.177L151.76+256.177C150.25+256.177+149.025+254.953+149.025+253.442L149.025+253.442C149.025+251.931+150.25+250.707+151.76+250.707Z",
    opacity: 1,
    fill: "#eee7e7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.735+320L179.056+320C180.567+320+181.791+321.225+181.791+322.735L181.791+322.735C181.791+324.246+180.567+325.471+179.056+325.471L152.735+325.471C151.225+325.471+150+324.246+150+322.735L150+322.735C150+321.225+151.225+320+152.735+320Z",
    opacity: 1,
    fill: "#eee7e7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 8,
    d: "M972.206+185.713L1129.49+185.713C1134.01+185.713+1137.67+189.377+1137.67+193.897L1137.67+442.011C1137.67+446.531+1134.01+450.195+1129.49+450.195L972.206+450.195C967.686+450.195+964.022+446.531+964.022+442.011L964.022+193.897C964.022+189.377+967.686+185.713+972.206+185.713Z",
    fill: "#8abeec",
    strokeLinecap: "butt",
    opacity: 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1113.36+450.195C1113.36+449.025+1114.33+448.075+1115.53+448.075C1116.73+448.075+1117.7+449.025+1117.7+450.195C1117.7+451.366+1116.73+452.316+1115.53+452.316C1114.33+452.316+1113.36+451.366+1113.36+450.195Z",
    opacity: 1,
    fill: "#d6f2fa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980.614+194.563L1121.08+194.563C1125.72+194.563+1129.49+198.227+1129.49+202.747L1129.49+300.625C1129.49+305.145+1125.72+308.809+1121.08+308.809L980.614+308.809C975.971+308.809+972.206+305.145+972.206+300.625L972.206+202.747C972.206+198.227+975.971+194.563+980.614+194.563Z",
    opacity: 1,
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dabca4",
    strokeWidth: 0.1,
    d: "M1115.2+205.189L1115.2+205.189C1116.58+205.189+1117.7+206.308+1117.7+207.689L1117.7+207.747C1117.7+209.128+1116.58+210.247+1115.2+210.247L1115.2+210.247C1113.82+210.247+1112.7+209.128+1112.7+207.747L1112.7+207.689C1112.7+206.308+1113.82+205.189+1115.2+205.189Z",
    fill: "#dd4848",
    strokeLinecap: "butt",
    opacity: 0.989868,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dabca4",
    strokeWidth: 0.1,
    d: "M1107.1+205.307L1107.1+205.307C1108.48+205.307+1109.6+206.427+1109.6+207.807L1109.6+207.866C1109.6+209.246+1108.48+210.366+1107.1+210.366L1107.1+210.366C1105.72+210.366+1104.6+209.246+1104.6+207.866L1104.6+207.807C1104.6+206.427+1105.72+205.307+1107.1+205.307Z",
    fill: "#e2d270",
    strokeLinecap: "butt",
    opacity: 0.989868,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dabca4",
    strokeWidth: 0.1,
    d: "M982.5+210L1014.19+210C1015.57+210+1016.69+211.119+1016.69+212.5L1016.69+212.5C1016.69+213.881+1015.57+215+1014.19+215L982.5+215C981.119+215+980+213.881+980+212.5L980+212.5C980+211.119+981.119+210+982.5+210Z",
    fill: "#75ee72",
    strokeLinecap: "butt",
    opacity: 0.989868,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dabca4",
    strokeWidth: 0.1,
    d: "M982.244+220L988.656+220C989.895+220+990.899+221.005+990.899+222.244L990.899+222.244C990.899+223.483+989.895+224.487+988.656+224.487L982.244+224.487C981.005+224.487+980+223.483+980+222.244L980+222.244C980+221.005+981.005+220+982.244+220Z",
    fill: "#ffffff",
    strokeLinecap: "butt",
    opacity: 0.989868,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dabca4",
    strokeWidth: 0.1,
    d: "M1022.5+210L1043.54+210C1044.93+210+1046.04+211.119+1046.04+212.5L1046.04+212.5C1046.04+213.881+1044.93+215+1043.54+215L1022.5+215C1021.12+215+1020+213.881+1020+212.5L1020+212.5C1020+211.119+1021.12+210+1022.5+210Z",
    fill: "#ffffff",
    strokeLinecap: "butt",
    opacity: 0.989868,
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer 2",
    vectornatorLayerName: "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#dabca4",
    strokeWidth: 0.1,
    d: "M18.4439+551.702L1170.78+551.702L1170.78+572.08L18.4439+572.08L18.4439+551.702Z",
    fill: "url(#RadialGradient_3)",
    strokeLinecap: "butt",
    opacity: 0.989868,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dabca4",
    strokeWidth: 0.1,
    d: "M18.5033+551.766L62.7448+499.817L1058.47+500.58L1131.75+500.636L1170.8+551.716",
    fill: "url(#RadialGradient_4)",
    strokeLinecap: "butt",
    opacity: 0.989868,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.151+270.08L523.704+270.08C524.893+270.08+525.856+271.043+525.856+272.231L525.856+272.231C525.856+273.419+524.893+274.382+523.704+274.382L493.151+274.382C491.963+274.382+491+273.419+491+272.231L491+272.231C491+271.043+491.963+270.08+493.151+270.08Z",
    opacity: 0.989868,
    fill: "#eee7e7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.176+290L460.138+290C460.788+290+461.314+290.527+461.314+291.176L461.314+291.176C461.314+291.826+460.788+292.352+460.138+292.352L451.176+292.352C450.527+292.352+450+291.826+450+291.176L450+291.176C450+290.527+450.527+290+451.176+290Z",
    opacity: 0.989868,
    fill: "#eee7e7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.683+346.498L459.645+346.498C460.294+346.498+460.821+347.024+460.821+347.674L460.821+347.674C460.821+348.323+460.294+348.85+459.645+348.85L450.683+348.85C450.033+348.85+449.507+348.323+449.507+347.674L449.507+347.674C449.507+347.024+450.033+346.498+450.683+346.498Z",
    opacity: 0.989868,
    fill: "#eee7e7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.196+290L507.158+290C507.808+290+508.334+290.527+508.334+291.176L508.334+291.176C508.334+291.826+507.808+292.352+507.158+292.352L498.196+292.352C497.547+292.352+497.02+291.826+497.02+291.176L497.02+291.176C497.02+290.527+497.547+290+498.196+290Z",
    opacity: 0.989868,
    fill: "#eee7e7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.703+346.498L506.665+346.498C507.314+346.498+507.841+347.024+507.841+347.674L507.841+347.674C507.841+348.323+507.314+348.85+506.665+348.85L497.703+348.85C497.053+348.85+496.527+348.323+496.527+347.674L496.527+347.674C496.527+347.024+497.053+346.498+497.703+346.498Z",
    opacity: 0.989868,
    fill: "#eee7e7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.176+290L550.138+290C550.788+290+551.314+290.527+551.314+291.176L551.314+291.176C551.314+291.826+550.788+292.352+550.138+292.352L541.176+292.352C540.527+292.352+540+291.826+540+291.176L540+291.176C540+290.527+540.527+290+541.176+290Z",
    opacity: 0.989868,
    fill: "#eee7e7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.683+346.498L549.645+346.498C550.294+346.498+550.821+347.024+550.821+347.674L550.821+347.674C550.821+348.323+550.294+348.85+549.645+348.85L540.683+348.85C540.033+348.85+539.507+348.323+539.507+347.674L539.507+347.674C539.507+347.024+540.033+346.498+540.683+346.498Z",
    opacity: 0.989868,
    fill: "#eee7e7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.5+293L470.97+292.03L470+291.5L470.97+290.97L471.5+290L472.03+290.97L473+291.5L472.03+292.03L471.5+293Z",
    opacity: 0.989868,
    fill: "#c9ea59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.007+349.498L470.476+348.528L469.507+347.998L470.476+347.467L471.007+346.498L471.537+347.467L472.507+347.998L471.537+348.528L471.007+349.498Z",
    opacity: 0.989868,
    fill: "#c9ea59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.5+293L516.97+292.03L516+291.5L516.97+290.97L517.5+290L518.03+290.97L519+291.5L518.03+292.03L517.5+293Z",
    opacity: 0.989868,
    fill: "#c9ea59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.007+349.498L516.476+348.528L515.507+347.998L516.476+347.467L517.007+346.498L517.537+347.467L518.507+347.998L517.537+348.528L517.007+349.498Z",
    opacity: 0.989868,
    fill: "#c9ea59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.5+293L561.97+292.03L561+291.5L561.97+290.97L562.5+290L563.03+290.97L564+291.5L563.03+292.03L562.5+293Z",
    opacity: 0.989868,
    fill: "#c9ea59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.007+349.498L561.476+348.528L560.507+347.998L561.476+347.467L562.007+346.498L562.537+347.467L563.507+347.998L562.537+348.528L562.007+349.498Z",
    opacity: 0.989868,
    fill: "#c9ea59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060.78+494.655L1087.67+494.655C1090.18+494.655+1092.22+496.694+1092.22+499.211L1092.22+503.843C1092.22+506.359+1090.18+508.399+1087.67+508.399L1060.78+508.399C1058.26+508.399+1056.22+506.359+1056.22+503.843L1056.22+499.211C1056.22+496.694+1058.26+494.655+1060.78+494.655Z",
    opacity: 1,
    fill: "url(#RadialGradient_5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.045+494.655L325.932+494.655C328.449+494.655+330.489+496.694+330.489+499.211L330.489+503.843C330.489+506.359+328.449+508.399+325.932+508.399L299.045+508.399C296.529+508.399+294.489+506.359+294.489+503.843L294.489+499.211C294.489+496.694+296.529+494.655+299.045+494.655Z",
    opacity: 1,
    fill: "url(#RadialGradient_6)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer 5",
    vectornatorLayerName: "Layer 5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M896.122+546.614L902.73+566.199L914.409+587.922L922+607.659L920.832+622.374L917.445+630.758L867.344+630.758L851.344+614.783L840.599+597.031L838.032+590.729L491.574+586.788L504.745+606.691L512.978+609.977L527.77+611.339",
    opacity: 1,
    fill: "#c4a290"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.064+547.041L898.547+566.255L910.004+587.566L917.451+606.928L916.305+621.365L912.983+629.589L863.831+629.589L848.135+613.917L837.594+596.502L835.075+590.319L496.671+590.428L508.107+605.979L516.184+609.203L527.353+610.324",
    opacity: 1,
    fill: "#ab806a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.495+629.871L524.284+596.556L497.731+591.185L482.402+580.236L476.38+523.852L472+464.731L476.927+446.666L488.424+433.528L531.126+413.273L578.208+392.471L605.867+382.958L629.67+371.669L663.066+367.29L695.368+366.434L698.372+370.813L711.036+371.962L730.951+371.122L759.967+383.165L790.625+386.997L815.261+389.187L831.137+402.325L851.941+430.791L871.65+462.541L886.431+483.343L900.666+508.524L912.608+524.764L913.528+538.794L903.403+559.434L882.052+572.573L860.701+586.258L843.182+595.017L841.433+630.542",
    opacity: 1,
    fill: "#a172da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.947+382.902L601.237+354.045L595.549+341.812L592.584+323.804L588.327+323.355L580.668+311.027L578.865+300.9L579.571+294.345L580.808+285.652L580.912+281.647L583.571+276.836L585.953+278.747L587.152+278.034L587.793+264.147L590.548+251.087L594.613+237.529L600.647+225.215L608.122+217.627L619.008+209.542L627.665+205.687L636.846+204.194L646.813+201.458L658.617+200.96L671.602+203.075L682.75+206.184L692.98+210.911L705.571+221.235L711.85+230.762L717.029+242.091L717.531+253.7L718.591+270.004L718.402+277.853L717.436+281.369L716.431+285.027L725.077+284.406L727.428+287.967L728.434+289.49L728.434+292.309L728.434+300.9L727.062+307.411L725.715+313.188L721.29+319.878L713.403+324.925L708.805+327.977L705.914+329.563L701.604+330.46L699.117+339.33L698.181+346.725L698.025+353.232L698.259+364.472L698.491+372.386L704.341+374.72",
    opacity: 1,
    fill: "#c4a290"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.67+392.818L607.46+381.85L608.577+351.863L603.591+340.556L600.993+323.911L597.261+323.496L587.921+312.439L586.474+302.123L588.281+295.222L589.37+288.018L589.273+283.475L590.774+281.67L593.1+281.912L596.105+284.481L596.793+268.77L599.207+256.698L602.771+244.166L608.06+232.784L614.613+225.771L624.155+218.298L631.743+214.734L639.791+213.355L648.529+210.825L658.876+210.366L670.258+212.32L680.03+215.194L688.998+219.563L700.035+229.105L708.657+242.902L711.877+255.318L712.681+267.16L712.106+280.381L709.577+288.544L712.858+288.803L715.107+287.454L717.805+287.061L720.054+289.309L720.897+294.256L720.391+300.889L718.873+308.758L717.693+314.099L713.814+320.282L706.9+324.947L702.291+326.578L697.569+325.285L696.557+330.063L694.377+338.261L693.557+345.097L693.42+351.111L693.625+361.501L694.198+370.839L706.88+375.418",
    opacity: 1,
    fill: "#ab806a"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dabca4",
    strokeWidth: 0.1,
    d: "M544.918+625.657L546.158+625.657",
    fill: "none",
    strokeLinecap: "butt",
    opacity: 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dabca4",
    strokeWidth: 0.1,
    d: "M543.666+625.657L532.056+591.154L543.666+625.657Z",
    fill: "#3a6bab",
    strokeLinecap: "round",
    opacity: 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dabca4",
    strokeWidth: 0.1,
    d: "M544.918+625.657L546.158+625.657",
    fill: "none",
    strokeLinecap: "butt",
    opacity: 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dabca4",
    strokeWidth: 0.1,
    d: "M543.666+625.657L532.056+591.154L543.666+625.657Z",
    fill: "#3a6bab",
    strokeLinecap: "round",
    opacity: 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.606+627.227L524.191+596.222L498.054+591.25L491.945+587.052L488.89+573.661L486.929+523.271L482.764+467.049L487.449+449.869L498.383+437.375L538.991+418.114L583.765+398.332L607.714+381.673L635.384+387.083L676.457+384.613L698.544+372.408L707.439+375.721L729.02+378.029L756.613+389.482L785.768+393.126L809.196+395.208L824.295+407.702L844.078+434.772L862.821+464.966L876.878+484.748L890.414+508.695L903.43+526.395L903.514+559.259L893.85+565.313L874.651+577.316L854.86+589.178L843.455+594.88L841.626+626.617",
    opacity: 1,
    fill: "#925ed0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChuckFooter);
export default __webpack_public_path__ + "static/media/chuckFooter.2c7df57768511400246e84675a7dba7c.svg";
export { ForwardRef as ReactComponent };